import React from 'react';
import { utils, writeFile } from 'xlsx';
import { RiFileExcel2Line } from "react-icons/ri";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: '14px',
    },
}));

const ExportTableToExcel = ({ tableData, columnConfig, fileName = 'ExportedData' }) => {

    const exportToExcel = () => {
        const worksheetData = tableData.map((row) => {
            const rowData = {};
            columnConfig.forEach((col) => {
                const value = row[col.value];
                rowData[col.label] = (value === null || value === undefined || value === "") ? "-" : value;
            });
            return rowData;
        });

        const worksheet = utils.json_to_sheet(worksheetData);
        const workbook = utils.book_new();

        utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        writeFile(workbook, `${fileName}.xlsx`);
    };


    return (
        <div>
            <BootstrapTooltip title={"Excel Export"} placement="top">
                <div className='WeeklyTaskRefreshParent' onClick={exportToExcel}>
                    <RiFileExcel2Line className="WeeklyRefreshIcon" style={{fontSize:"19px"}}/>
                </div>
            </BootstrapTooltip>
        </div>
    );
};


export default ExportTableToExcel;